import React, {useState, useEffect} from 'react';
import { Button, IESAuthUtilV2 } from "@activehub/common-components-spa-resource";
import "./AccessCodeRegistrationComplete.scss";
import { IESConfig, IESOptions } from '../../constants/IESConfig';


export default function AccessCodeRegistrationComplete(props) {
  const [iesSession, setIesSession] = useState(null);
  const setClient = (e) => {
    sessionStorage.setItem("LOGINTYPE", e.target.id)
    iesSession.login();
  }

  useEffect(() => {
    const userIdKey = Object.keys(localStorage).find(key => key.includes('PiUserId'))
    const successUrl = window.location.href.includes('/login') || window.location.href.includes('/access-code-registration')? window.location.href.split("#")[0] : "";
    const loginTypeVal = sessionStorage.getItem("LOGINTYPE");
    const loginParams = (loginTypeVal) ? { queryParams: { loginType: loginTypeVal } } : {};
    const iesSubscription = IESAuthUtilV2.load({
        ...IESConfig,
        callbackURL: successUrl,
        domain: window.location.hostname,
        ...loginParams
    }, IESOptions).subscribe((session) => {
        console.count("IES Session")
        setIesSession(session);
    });

    return () => iesSubscription.unsubscribe();
  }, []);

  return (
    <>
      <div className="access-code-user-reg-complete">
              <h4>Thank you for registering</h4>
              <div className="reg-complete-message">
                <div className='reg-complete-email-info'>You will shortly receive an email with your username and temporary password you can use to sign in.</div>
                <div className='reg-complete-ebook-info'>You can access your ebook from My Library.</div>
              </div>
              <Button
                className="access-code-sign-in"
                tabIndex={true ? 0 : -1}
                onClick={setClient}
              >
                Sign in
              </Button>
          </div>
    </>
  )
}